<div [class]="modalClass">
    <mat-toolbar matDialogTitle class="mat-accent m-0">


        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center"
            style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center space-between; align-items: center; flex: 1 1 1e-09px;">
            <span class="title dialog-title" translate>{{dialogTitle}}</span>
            <div class="dialog-actions">
                <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center"
                    *ngIf="action !== recordAction.View">

                    <ng-content select="button"></ng-content>

                </div>
                <button class="close-button" (click)="close()" aria-label="Close dialog">
                    <mat-icon class="material-icons-outlined close-button">disabled_by_default</mat-icon>
                </button>
            </div>


        </div>

    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" wtfPerfectScrollbar>

        <ng-content></ng-content>

    </div>
</div>